var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/menu"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    strokeOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4112",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 6,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.5C5 6.67157 5.67157 6 6.5 6H23.5C24.3284 6 25 6.67157 25 7.5C25 8.32843 24.3284 9 23.5 9H6.5C5.67157 9 5 8.32843 5 7.5ZM5 15.5C5 14.6716 5.67157 14 6.5 14H23.5C24.3284 14 25 14.6716 25 15.5C25 16.3284 24.3284 17 23.5 17H6.5C5.67157 17 5 16.3284 5 15.5ZM6.5 22C5.67157 22 5 22.6716 5 23.5C5 24.3284 5.67157 25 6.5 25H23.5C24.3284 25 25 24.3284 25 23.5C25 22.6716 24.3284 22 23.5 22H6.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/accent/orange/base"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 30,
    height: 30,
    fill: "#E37B3C"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.0c989074684a252e8c3e92026bddf8d0.svg";
export { ForwardRef as ReactComponent };